export default __webpack_public_path__ + "static/media/calendarDown.ddc37cf2.svg";